import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Accordion, AccordionDetails } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 0px !important;
        border-bottom: 1px solid #B2B2B2;
        padding-bottom: .8rem;

        ::before {
            display: none;
        }

        &.Mui-expanded {
            margin: 0rem;
        }
        
        #panel1d-header {
            min-height: 0;
            height: auto;
            padding: 0 1.25rem 0 0;

            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        .MuiAccordionSummary-expandIconWrapper {
            svg {
                width: auto;
                height: 45px;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 100%;
        }
`);

export const AccordionDetailsCustom = styled(AccordionDetails)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        padding: 1.5625rem 0 0;
        justify-content: center;

        .store-link {
          font-weight: bold;
        }

        table {
          display: block;
          border-collapse: collapse;
          max-width: calc(100vw - 2rem);
          overflow-x: scroll;
          width: 100%;
          margin: 1.5rem 0;

          tr,th,td {
            border: 1px solid black;
            text-align: center;
            padding: 0.5rem;
          }

          th {
            background-color: #0c1c33;
            color: white;
          }
        }

        ul {
          margin: 1rem;
          list-style-type: lower-alpha;
        }

        a {
            text-decoration: none;
            color: ${theme?.palette.primary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding-top: 1.1875rem;

            table {
                max-width: calc(100vw - 39rem);
            }
        }
`);

export const LinkExternal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .625rem;
    font-style: normal;
    font-weight: 600;
    text-decoration: none;
    color: ${theme?.palette.primary.main};
    margin: .8rem auto 0;
    svg {
        margin-left: .63rem;
    }
`);

